import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setUpdateQuestionError } from "../../repository/slice";

function* updateAnonymousComplaintWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.put, "/api/admin/complaint", payload);
        if (isError) {
            yield put(setUpdateQuestionError(message));
        } else {
            yield put(setUpdateQuestionError(null));
        }
    } catch (error) {
        console.error("updateAnonymousComplaintWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* updateAnonymousComplaintWatcher() {
    yield takeLatest("@saga/UPDATE_ANONYMOUS_COMPLAINT", updateAnonymousComplaintWorker);
};
